import { render } from "./DocumentosModelo.vue?vue&type=template&id=fb9f4266&scoped=true"
import script from "./DocumentosModelo.vue?vue&type=script&lang=js"
export * from "./DocumentosModelo.vue?vue&type=script&lang=js"

import "./DocumentosModelo.vue?vue&type=style&index=0&id=fb9f4266&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb9f4266"]])

export default __exports__